import { render, staticRenderFns } from "./SchoolTypeAdd.vue?vue&type=template&id=11939f01"
import script from "./SchoolTypeAdd.vue?vue&type=script&lang=js"
export * from "./SchoolTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports